import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconUserFilledStyle0 = cosmosIconCss;

const CosmosIconUserFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconUserFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c425996f7bb542e341fa110fcb69904996914f32', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '266e137277365c6a594f509c37505643671897f6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f56d081cbd9342b3a08e7656e4906ce96afa3526', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 3.5a3.81 3.81 0 0 1 2.9 1.191c.693.8.99 1.871.805 2.914l-.268 2.306A3.352 3.352 0 0 1 11 13a3.35 3.35 0 0 1-3.436-3.09l-.272-2.324a3.508 3.508 0 0 1 .81-2.897A3.811 3.811 0 0 1 11 3.5ZM8.47 14.064a5.488 5.488 0 0 0 5.072 0 .5.5 0 0 1 .416-.033 6.115 6.115 0 0 1 4.047 5.44.504.504 0 0 1-.505.529H4.512a.504.504 0 0 1-.505-.53 6.115 6.115 0 0 1 4.047-5.44.5.5 0 0 1 .416.034Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconUserFilledStyle0; }
}, [1, "cosmos-icon-user-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-user-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-user-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconUserFilled$1);
            }
            break;
    } });
}

const CosmosIconUserFilled = CosmosIconUserFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconUserFilled, defineCustomElement };
